import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.collage-left-right' ).each( function( key, val ) {
        const badge = $( this ).find( '.clr__badge' )[0];
        let topOffset = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).outerHeight();
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top ' + topOffset,
            end: 'bottom top',
            scrub: 1,
          },
        } );
        tl.to( badge, {rotate: '360deg', ease: 'linear'}, 0 );
      } );
    },
  };

  app.registerComponent( 'collage-left-right', COMPONENT );
} )( app );
